<template>
  <section class="products-section">
    <div class="products-container">
      <header class="products-intro">
        <span class="products-intro-kicker">数字档案产品体系</span>
        <h2>专业产品，覆盖档案全流程</h2>
        <p>以成熟的软件产品与智能能力，帮助提升档案管理质量和工作效率，让档案管理回归简单。</p>
      </header>

      <div class="product-list">
        <article v-for="product in products" :key="product.title" class="product-entry">
          <div class="product-entry-visual">
            <span class="product-entry-category">{{ product.category }}</span>
            <div class="product-entry-orbit product-entry-orbit--one"></div>
            <div class="product-entry-orbit product-entry-orbit--two"></div>
            <div class="product-entry-panel">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
          <div class="product-entry-body">
            <div class="product-entry-content">
              <h3>{{ product.title }}</h3>
              <p>{{ product.description }}</p>
              <ul class="product-entry-tags" aria-label="产品能力">
                <li v-for="tag in product.tags" :key="tag">{{ tag }}</li>
              </ul>
            </div>
            <router-link :to="product.to" class="product-entry-link">了解更多</router-link>
          </div>
        </article>
      </div>
    </div>

    <div class="products-data">
      <div class="products-container products-data-content">
        <article v-for="item in stats" :key="item.label" class="stat-item">
          <strong>{{ item.value }}</strong>
          <span>{{ item.label }}</span>
          <p>{{ item.description }}</p>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomeProducts',
  data () {
    return {
      products: [
        {
          category: '档案管理',
          title: '档案管理平台',
          description: '覆盖收集、管理、检索、利用、保管、统计、编研与权限管理等核心业务。',
          tags: ['采集归档', '权限控制', '统计分析'],
          to: '/product/manage'
        },
        {
          category: '声像资源',
          title: '多媒体档案管理系统',
          description: '支持音视频处理、元数据捕获、智能检索、人脸标注与以图搜图。',
          tags: ['音视频处理', '智能检索', '以图搜图'],
          to: '/product/identification'
        },
        {
          category: '质量检测',
          title: '四性检测系统',
          description: '对电子文件真实性、安全性、完整性与可用性进行检测和报告管理。',
          tags: ['真实性','可用性', '完整性', '安全性'],
          to: '/product/use'
        },
        {
          category: '智能鉴定',
          title: '智能开放鉴定系统',
          description: '提供智能鉴定、协同会审、规则管理与鉴定统计能力。',
          tags: ['规则管理', '协同会审', '鉴定统计'],
          to: '/product/open-identification'
        },
        {
          category: '知识资产',
          title: '知识管理系统',
          description: '支持知识沉淀、分享、全文检索、知识图谱与文档调用接口。',
          tags: ['全文检索', '知识图谱', '知识复用'],
          to: '/product/knowledge'
        },
        {
          category: '智能加工',
          title: '智能著录系统',
          description: '通过看图、OCR 和扫描分件等能力，提高档案著录效率与准确度。',
          tags: ['OCR识别', '看图著录', '扫描分件'],
          to: '/product/intelligence'
        }
      ],
      stats: [
        { value: '100%', label: '降低风险率', description: '从产品定义到上线测试，持续保障系统可用性。' },
        { value: '70%', label: '战略伙伴', description: '众多客户选择长期合作，共同推进档案数字化。' },
        { value: '300+', label: '经典案例', description: '以扎实的产品与服务能力赢得客户信赖。' }
      ]
    }
  }
}
</script>

<style scoped>
.products-section { background: #f4f7fb; }
.products-container { width: min(1200px, calc(100% - 64px)); margin: 0 auto; }
.products-section > .products-container { padding: 104px 0 112px; }
.products-intro { max-width: 680px; margin: 0 auto; text-align: center; }
.products-intro-kicker { display: inline-block; margin-bottom: 18px; color: #2e73e8; font-size: 13px; letter-spacing: .18em; }
.products-intro h2 { margin: 0; color: #20344e; font-size: clamp(30px, 3vw, 42px); font-weight: 600; line-height: 1.4; }
.products-intro p { max-width: 620px; margin: 18px auto 0; color: #728197; font-size: 15px; line-height: 1.9; }
.product-list { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 28px; margin-top: 56px; }
.product-entry { display: flex; min-height: 438px; flex-direction: column; overflow: hidden; border: 1px solid #e1e8f2; background: #fff; box-shadow: 0 12px 32px rgba(35, 64, 102, .06); transition: border-color .25s ease, box-shadow .25s ease, transform .25s ease; }
.product-entry:hover { border-color: #a9c5f2; box-shadow: 0 20px 42px rgba(35, 64, 102, .13); transform: translateY(-5px); }
.product-entry-visual { position: relative; height: 180px; overflow: hidden; background: linear-gradient(135deg, #0c2d56, #146d9e); }
.product-entry-visual::before { position: absolute; inset: 0; background-image: linear-gradient(rgba(127, 216, 255, .1) 1px, transparent 1px), linear-gradient(90deg, rgba(127, 216, 255, .1) 1px, transparent 1px); background-size: 24px 24px; content: ''; opacity: .55; }
.product-entry-visual::after { position: absolute; right: -26px; bottom: -45px; width: 220px; height: 220px; border: 1px solid rgba(112, 210, 255, .35); border-radius: 50%; box-shadow: 0 0 50px rgba(72, 205, 255, .2); content: ''; }
.product-entry-number { position: absolute; z-index: 2; top: 22px; left: 24px; color: #2e73e8; font-size: 34px; font-weight: 600; line-height: 1; }
.product-entry-category { position: absolute; z-index: 2; top: 27px; right: 23px; padding: 6px 10px; border: 1px solid rgba(112, 210, 255, .42); background: rgba(8, 37, 72, .35); color: #9edcff; font-size: 12px; letter-spacing: .08em; }
.product-entry-orbit { position: absolute; border: 1px solid rgba(112, 210, 255, .5); border-radius: 50%; }
.product-entry-orbit--one { top: 30px; right: 43px; width: 118px; height: 118px; }
.product-entry-orbit--two { top: 61px; right: 74px; width: 56px; height: 56px; background: rgba(255, 255, 255, .08); }
.product-entry-panel { position: absolute; right: 20px; bottom: 20px; left: 24px; display: flex; height: 24px; align-items: center; gap: 7px; padding: 0 10px; border: 1px solid rgba(112, 210, 255, .38); background: rgba(5, 30, 63, .42); }
.product-entry-panel span { display: block; width: 18%; height: 4px; background: #6fbfe8; }
.product-entry-panel span:first-child { width: 35%; background: #72d5ff; }
.product-entry-panel span:last-child { width: 28%; background: #2f87b5; }
.product-entry-body { display: flex; flex: 1; flex-direction: column; padding: 27px 26px 25px; }
.product-entry-content { flex: 1; }
.product-entry h3 { margin: 0; color: #20344e; font-size: 21px; font-weight: 600; line-height: 1.45; }
.product-entry p { min-height: 52px; margin: 12px 0 0; color: #728197; font-size: 14px; line-height: 1.8; }
.product-entry-tags { display: flex; flex-wrap: wrap; gap: 8px; margin: 20px 0 0; padding: 0; list-style: none; }
.product-entry-tags li { padding: 6px 10px; background: #f0f5fd; color: #5577a8; font-size: 12px; line-height: 1; }
.product-entry-link { display: inline-flex; width: fit-content; align-items: center; gap: 14px; min-height: 38px; margin-top: 25px; padding: 0 15px; border: 1px solid #b7cbed; color: #2e73e8; font-size: 13px; text-decoration: none; transition: background-color .2s ease, border-color .2s ease, color .2s ease; }
.product-entry-link span { font-size: 17px; line-height: 1; transition: transform .2s ease; }
.product-entry-link:hover, .product-entry-link:focus { border-color: #55caff; background: #168bb7; color: #fff; outline: none; }
.product-entry-link:hover span, .product-entry-link:focus span { color: #fff; transform: translateX(3px); }
.product-entry-link:focus-visible { outline: 3px solid rgba(85, 202, 255, .32); outline-offset: 3px; }
.products-data { background: #20344e; }
.products-data-content { display: grid; grid-template-columns: repeat(3, 1fr); min-height: 300px; align-items: center; gap: 70px; color: #fff; }
.stat-item { padding: 8px 0; border-left: 1px solid rgba(255, 255, 255, .22); text-align: center; }
.stat-item:first-child { border-left: 0; }
.stat-item strong, .stat-item span { display: block; }
.stat-item strong { color: #fff; font-size: 46px; font-weight: 600; }
.stat-item span { margin-top: 8px; color: #d7e4f8; font-size: 18px; }
.stat-item p { max-width: 230px; margin: 15px auto 0; color: #a9bbd4; font-size: 13px; line-height: 1.7; }
@media (max-width: 1024px) {
  .products-container { width: calc(100% - 64px); }
  .product-list { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}
@media (max-width: 680px) {
  .products-container { width: calc(100% - 40px); }
  .products-section > .products-container { padding: 72px 0 68px; }
  .products-intro-kicker { margin-bottom: 14px; }
  .products-intro h2 { font-size: 30px; }
  .products-intro p { font-size: 14px; }
  .product-list { grid-template-columns: 1fr; gap: 18px; margin-top: 40px; }
  .product-entry { min-height: 0; }
  .product-entry-visual { height: 132px; }
  .product-entry-body { padding: 24px 22px 22px; }
  .product-entry h3 { font-size: 19px; }
  .product-entry p { min-height: 0; }
  .products-data-content { display: block; min-height: 0; padding: 28px 0; }
  .stat-item { padding: 25px 0; border-top: 1px solid rgba(255, 255, 255, .22); border-left: 0; }
  .stat-item:first-child { border-top: 0; }
  .stat-item strong { font-size: 38px; }
}
@media (prefers-reduced-motion: reduce) {
  .product-entry, .product-entry-link, .product-entry-link span { transition: none; }
}
</style>
